import { State } from "@hookstate/core"
import DatePicker from "react-datepicker";
import { CustomDateInput } from "../../../components/CustomDateInput";
import { useEffect } from "react";
import Cross from "../../../assets/icons/Cross";
import { psychologistAppointmentFormatDefault, psychologistAppointmentFormats } from "../../../misc/constants";
import InputField from "../../../components/input-field/InputField";
import { onInputChangeNative } from "../../../misc/utils";

export const PsychologyListControls = ({ parentState }: { parentState: State<Record<string, any>> }) => {
    const state = parentState.get();
    const form = state.form || {};

    useEffect(() => {
        parentState.merge({
            form: {
                format: '0'
            }
        })
    }, []);

    const updateForm = (key: string, value: any) => {
        //@ts-ignore
        parentState.form[key].set(value);
    }

    const onFormInputChange = (key: string) => (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> | React.ChangeEvent<HTMLSelectElement>) => {
        updateForm(key, e.target.value);
    }

    const onFormInputChangeDate = (key: string) => (date: Date | null) => {
        updateForm(key, date);
    }

    const resetForm = (fields: string[]) => () => {
        const resetObject: any = {}
        for (const f of fields) {
            resetObject[f] = '';
        }
        //@ts-ignore
        parentState.form.merge(resetObject)
    }

    return (
        <div className="flex flex-col">
            <div className="flex flex-row pt-2 pl-2 pb-4 pr-4 justify-between items-center">
                <div className="flex flex-row items-center gap-4">
                    <div className="flex flex-col gap-2">
                        <span className="font-medium text-sm leading-[15.4px] text-valley-gray">
                            Даты
                        </span>
                        <div className="flex flex-row items-center gap-2">
                            <DatePicker
                                selected={form.start_date}
                                onChange={onFormInputChangeDate('start_date')}
                                customInput={<CustomDateInput />}
                                dateFormat="dd/MM/yyyy HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                timeCaption="Время"
                            />
                            <DatePicker
                                selected={form.end_date}
                                onChange={onFormInputChangeDate('end_date')}
                                customInput={<CustomDateInput />}
                                dateFormat="dd/MM/yyyy HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                timeCaption="Время"
                            />
                            <button onClick={resetForm(['start_date', 'end_date'])} className={`flex flex-row p-1 rounded-lg ${form.start_date || form.end_date ? 'bg-valley-red' : 'bg-[#F12D2D1F] opacity-[12]'}`}>
                                <Cross additionalStyle={form.start_date || form.end_date ? 'text-white' : 'text-valley-red'} />
                            </button>
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <span className="font-medium text-sm leading-[15.4px] text-valley-gray">
                            Тип встречи
                        </span>
                        <div className="flex flex-row items-center gap-2">
                            <InputField
                                wrapperClassName="flex flex-col gap-2"
                                additionalClassName="px-3 py-[10.5px] bg-valley-background-blue"
                                type="select"
                                id={"format"}
                                value={form.format}
                                handleChange={onFormInputChange("format")}
                                options={[psychologistAppointmentFormatDefault, ...psychologistAppointmentFormats].map(t => ({ label: t.label, value: t.value }))}
                            />
                            <button onClick={resetForm(['format'])} className={`flex flex-row p-1 rounded-lg ${Boolean(parseInt(form.format)) ? 'bg-valley-red' : 'bg-[#F12D2D1F] opacity-[12]'}`}>
                                <Cross additionalStyle={Boolean(parseInt(form.format)) ? 'text-white' : 'text-valley-red'} />
                            </button>
                        </div>
                    </div>
                </div>
                <button onClick={resetForm(['start_date', 'end_date', 'format'])} className={`flex flex-row items-center gap-2 px-3 py-[9px] rounded-lg ${form.start_date || form.end_date || Boolean(parseInt(form.format)) ? 'bg-valley-red' : 'bg-[#F12D2D1F] opacity-[12]'}`}>
                    <Cross additionalStyle={form.start_date || form.end_date || Boolean(parseInt(form.format)) ? 'text-white' : 'text-valley-red'} />
                    <span className={`font-bold text-[15px] leading-[18px] ${form.start_date || form.end_date || Boolean(parseInt(form.format)) ? 'text-white' : 'text-valley-red'}`}>
                        Сбросить все
                    </span>
                </button>
            </div>
            <div className="flex flex-row pt-2 pl-2 pb-4 pr-4">
                <InputField
                    wrapperClassName="flex-1"
                    type="text"
                    id="psychologists-list-search"
                    placeholder='Поиск'
                    handleChange={onFormInputChange('search')}
                    value={form.search}
                    additionalClassName="bg-valley-background-blue py-3 px-4 rounded-lg"
                />
            </div>
        </div>
    )
}